import React, { PropTypes } from 'react';

import Container from '../Container';
import ExternalLink from '../ExternalLink';

import { container, info, link, heading, help } from './styles.module.css';

/**
 * Help Prompt presentational component.
 */
const HelpPrompt = ({ title, message }) => (
  <div className={help}>
    <Container>
      <div className={container}>
        <h2 className={heading}>{title}</h2>
        <div className={info}>
          <p>{message}</p>
          <ExternalLink href="https://letsdothisuk.typeform.com/to/cMqHpY" className={link}>
            {'Talk to the team'}
          </ExternalLink>
        </div>
      </div>
    </Container>
  </div>
);

HelpPrompt.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
};

HelpPrompt.defaultProps = {
  message:
    'Our team are here to answer any questions you might have. We offer 24/7 booking support as a standard.',
  title: 'Got a question?',
};

export default HelpPrompt;



// WEBPACK FOOTER //
// ./app/src/components/HelpPrompt/index.jsx